import React from "react";
import BlogDashboard from "./BlogDashboard";

export default function Dashboard() {
  return <BlogDashboard />;
}
